import { validator } from '../core'

export const stringValidation = (name: string) => {
  return validator.string().required(`${name} is required`)
}
